//Paquetes NPM de GYF.
import { LogHelper } from 'com-gyf-webcore-loghelper';
import { Engine1Proxy, RestApiProxy, RabbitListener, SagasProxy, ConciergeProxy } from 'com-gyf-webcore-servicehub';

//Seteo de apiUrl
RestApiProxy.SetApiUrl();
export const GET_KIND_ENTERPRISE_DATA_RESULT = 'GET_KIND_ENTERPRISE_DATA_RESULT';
export const GET_KIND_ENTERPRISE_DATA = 'GET_KIND_ENTERPRISE_DATA';
export const GET_KIND_ENTERPRISE_DATA_ROUTTING = 'GET_KIND_ENTERPRISE_DATA_ROUTTING';
export const SELECT_RADIOBUTTON_TIPOEMPRESA = 'SELECT_RADIOBUTTON_TIPOEMPRESA';
export const SHOW_ERROR = 'SHOW_ERROR';
export const CANCEL = 'CANCEL';
export const FUNCTION_CODE_CREATE = 'Alta';
export const FUNCTION_CODE_QUERY = 'Consulta';
export const GET_ADMINISTRATOR_DATA = 'GET_ADMINISTRATOR_DATA';
export const GET_KIND_PRODUCT_DATA_RESULT = 'GET_KIND_PRODUCT_DATA_RESULT';
export const ACTUALIZAR_ESTADO_GLOBAL_TIPOEMPRESA = 'ACTUALIZAR_ESTADO_GLOBAL_TIPOEMPRESA';
export const ACTUALIZAR_TIPO_EMPRESA_NUEVA = 'ACTUALIZAR_TIPO_EMPRESA_NUEVA';
export const RESET_STATE_SOLICITUD_TIPO_EMPRESA = 'RESET_STATE_SOLICITUD_TIPO_EMPRESA';
export const ROUTE_TO_TARJETAS = 'ROUTE_TO_TARJETAS';
export const ROUTE_TO_EMPRESA = 'ROUTE_TO_EMPRESA';
export const ROUTE_TO_EMPRESA_FROM_TIPOEMPRESA = 'ROUTE_TO_EMPRESA_FROM_TIPOEMPRESA';
export const ROUTE_TO_CUENTA = 'ROUTE_TO_CUENTA';
export const ROUTE_TO_PRODUCTO = 'ROUTE_TO_PRODUCTO';
export const ROUTE_TO_CONFIRMACION = 'ROUTE_TO_CONFIRMACION';
export const ROUTE_TO_CANCEL = 'ROUTE_TO_CANCEL';
export const ELIMINAR_FUTURO_FROM_TIPO_EMPRESA = 'ELIMINAR_FUTURO_FROM_TIPO_EMPRESA';
export const ROUTE_TO_CUENTA_FROM_TIPO_EMPRESA = 'ROUTE_TO_CUENTA_FROM_TIPO_EMPRESA';
export const RESET_REDIRECT_TIPO_EMPRESA = 'RESET_REDIRECT_TIPO_EMPRESA';
export const RESET_SELECCIONES_CUENTA = 'RESET_SELECCIONES_CUENTA';
export const DESELECT_TIPO_EMPRESA = 'DESELECT_TIPO_EMPRESA';
export const ROUTE_TO_ADM_FROM_TIPOEMPRESA = 'ROUTE_TO_ADM_FROM_TIPOEMPRESA';
export const ROUTE_TO_VISTACLIENTE_FROM_TIPOEMPRESA = 'ROUTE_TO_VISTACLIENTE_FROM_TIPOEMPRESA';
export const ELIMINAR_EMPRESAS_EN_MEMORIA = 'ELIMINAR_EMPRESAS_EN_MEMORIA';

let _dispatch, _routingState, _tarjetas = null;
let userFeatures = [];

/**
 * Obtiene los datos para popular la pantalla.
 * @param {any} state
 * @param {any} currentScope
 */
export function getScreenData(currentScope) {
    LogHelper.In(getScreenData.name, currentScope);

    return (dispatch, getState) => {
        _dispatch = dispatch;

        const state = getState();

        _tarjetas = JSON.parse(JSON.stringify(state.tarjetas));

        //dispatch({ type: GET_ADMINISTRATOR_DATA, state });

        var currentScopeRequest = {
            "UserId": currentScope.UserId,
            "ProductCode": currentScope.ProductCode,
            "ProgramCode": currentScope.ProgramCode
        }

        ConciergeProxy.Execute((data) => _cargaInicialResultado(data), null, "GETFUNCTIONS", currentScopeRequest);
    }
}

/**
 * Routea a la pagina "Solicitud Empresa".
 */
export function routeToNuevaSolicitudCuenta() {
    LogHelper.In(routeToNuevaSolicitudCuenta.name);

    return (dispatch, getState) => {
        _dispatch = dispatch;

        dispatch({
            type: RESET_SELECCIONES_CUENTA,
        });

        dispatch({
            type: ROUTE_TO_CUENTA_FROM_TIPO_EMPRESA,
            empresas: getState().nuevaSolicitudTipoEmpresa
        });
    }
}

/**
 * Reset del state de la pantalla.
 */
export function resetStateSolicitudTipoEmpresa() {
    LogHelper.In(resetStateSolicitudTipoEmpresa.name);

    return (dispatch, getState) => {
        const { nuevaSolicitudTipoEmpresa, tarjetas } = getState();

        if (nuevaSolicitudTipoEmpresa.redirectToEmpresa == false) {
            dispatch({
                type: ACTUALIZAR_ESTADO_GLOBAL_TIPOEMPRESA,
                tipoEmpresa: (tarjetas.tipoEmpresa || nuevaSolicitudTipoEmpresa.tipoEmpresa).map(t => {
                    t.seleccionada = false;
                    return t;
                })
            });
        }

        if(!tarjetas.esModificacion && tarjetas.empresas && tarjetas.empresas.length > 0 && tarjetas.empresas.some(emp=>emp.esNueva)){
            dispatch({ type: ACTUALIZAR_TIPO_EMPRESA_NUEVA,tipoEmpresa: tarjetas.tipoEmpresa });
        }

        dispatch({ type: RESET_STATE_SOLICITUD_TIPO_EMPRESA });
    }
}

/**
 * Routea a la pagina "Administradora".
 */
export function routeToPrevious() {
    LogHelper.In(routeToPrevious.name);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: ROUTE_TO_ADMINISTRADORA_FROM_TIPO_EMPRESA });
    }
}

export function resetRedirectTipoEmpresa() {
    LogHelper.In(resetRedirectTipoEmpresa.name);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: RESET_REDIRECT_TIPO_EMPRESA });
    }
}

/**
 *
 */
export function routeToAdministradora() {
    LogHelper.In(routeToAdministradora.name);

    return (dispatch, getState) => {
        dispatch({ type: ROUTE_TO_ADM_FROM_TIPOEMPRESA });
    }
}

/**
 *
 */
export function routeToEmpresa(eliminaEmpresasCache) {
    LogHelper.In(routeToEmpresa.name);

    return (dispatch, getState) => {

        if(eliminaEmpresasCache) { 
            dispatch({ type: ELIMINAR_EMPRESAS_EN_MEMORIA });
        }

        dispatch({ type: ROUTE_TO_EMPRESA_FROM_TIPOEMPRESA });
    }
}

/**
 *
 */
export function routeToVistaCliente() {
    LogHelper.In(routeToVistaCliente.name);

    return (dispatch, getState) => {
        dispatch({ type: ROUTE_TO_VISTACLIENTE_FROM_TIPOEMPRESA });
    }
}

/**
 * Cancela el proceso de "Nueva Solicitud".
 */
export function cancel() {
    LogHelper.In(cancel.name);

    return (dispatch, getState) => {
        dispatch({ type: CANCEL });
    }
}

export function deselectTipoEmpresa() {
    LogHelper.In(deselectTipoEmpresa.name);

    return (dispatch, getState) => {
        dispatch({ type: DESELECT_TIPO_EMPRESA });
    }
}

/**
 * Selecciona in tipo de empresa.
 * @param {any} id
 * @param {any} codigo
 * @param {any} descripcion
 */

export function selectRadioButton(value) {
    LogHelper.In(selectRadioButton.name, value);
    return (dispatch, getState) => {
        _dispatch = dispatch;
        const state = getState();

        //Elimino el futuro si hay cambias el tipo de empresa. (Si seleccionas una distinta).
        /*if (state.tarjetas.tipoEmpresa != undefined) {
            let tipoEmpresaSeleccionado = state.tarjetas.tipoEmpresa.find(x => x.seleccionada == true);

            if (tipoEmpresaSeleccionado != undefined) {
                if (tipoEmpresaSeleccionado.Id != value.Id) {
                    dispatch({ type: ELIMINAR_FUTURO_FROM_TIPO_EMPRESA });
                }
            }
        }*/

        dispatch({
            type: SELECT_RADIOBUTTON_TIPOEMPRESA,
            value: value
        });

        dispatch({
            type: ACTUALIZAR_ESTADO_GLOBAL_TIPOEMPRESA,
            tipoEmpresa: value
        });
    }
}

/**
 * Muestra mensaje de error.
 */
export function showError() {
    LogHelper.In(showError.name);
    return (dispatch, getState) => {
        _dispatch = dispatch;
        dispatch({
            type: SHOW_ERROR
        });
    }
}

/*---------------------------FUNCIONES AUXILIARES----------------------------**/

function _cargaInicialResultado(data) {
    LogHelper.In(_cargaInicialResultado.name, data);

    userFeatures = JSON.parse(JSON.stringify(data)); //Todos los permisos por feature del usuario en el programa.
    let funcionesDelUsuario = JSON.parse(JSON.stringify(data.SOLICITUD)); //Permisos del usuario para la feature a utilizar.

    let permissions = {
        components: {
            Pantalla: { Active: false, Locked: false },
            RadioButtons: { Active: false, Locked: false },
            BotonesAnteriorSiguiente: { Active: false, Locked: false },
            BotonGuardarBorrador: { Active: false, Locked: false }
        },
        funcionesDelUsuario: {}
    };

    funcionesDelUsuario.forEach(p => { permissions.funcionesDelUsuario[p.Codigo_Funcion] = true; });

        if (permissions.funcionesDelUsuario.Alta == true) {
            permissions.components.Pantalla.Active = true;
            permissions.components.RadioButtons.Active = true;
            permissions.components.BotonGuardarBorrador.Active = true;

            if (permissions.funcionesDelUsuario.Consulta == true) {
                permissions.components.BotonesAnteriorSiguiente.Active = true;
            }
        } else {
            /*Si no tiene permisos sobre el alta, no es necesario que valide las demas funciones, ya que no
            será capaz de acceder a la pantalla*/
            permissions.components.Pantalla.Active = false;
        }
    
    if (permissions.components.Pantalla.Active == true) {
       // if (_tarjetas.tipoEmpresa == undefined) { ///////SE BORRA CONDICION PARA QUE SE VUELVA A CARGAR LOS TIPOS
       // EN CASO DE QUE SE VUELVA ATRAS EN EL PROCESO DE SOLICITUD
            let param = {
                'ADMINISTRADORA_ID': _tarjetas.administradora.Id,
                /*'TIPO_PERSONA': /*_tarjetas.tipoEmpresa*/
            }
            LogHelper.Out(_cargaInicialResultado.name, param, 'GET_ATLAS_CUENTA_TIPO_BY_ADMINISTRADORA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
            Engine1Proxy.AddDataSourcesRequests(param, 'GET_ATLAS_CUENTA_TIPO_BY_ADMINISTRADORA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
            Engine1Proxy.Execute(_loadNuevaSolicitudTipoEmpresaInitialStateData, null, permissions, "SOLICITUD");
        /*} else {
            let resultado = {
                'tipoEmpresa': _tarjetas.tipoEmpresa,
                'permissions': permissions,
                'showError': false
            }

            seleccionarTipoEmpresa(resultado.tipoEmpresa);
            _dispatch({ type: GET_KIND_PRODUCT_DATA_RESULT, resultado: resultado });
        }*/
    } else {
        let resultado = {
            'permissions': permissions,
            'showError': false
        }

        _dispatch({ type: GET_KIND_PRODUCT_DATA_RESULT, resultado: resultado });
    }
}

function seleccionarTipoEmpresa(tiposEmpresa) {
    LogHelper.In(seleccionarTipoEmpresa.name, tiposEmpresa);

    if (_tarjetas.id > 0) {
        //Logica de obtención del tipo de empresa seleccionado desde las tarjetas hacia abajo.
        let tarjetaSeleccionada;
        let cuentaSeleccionada;
        let empresaSeleccionada;
        tarjetaSeleccionada = _tarjetas.tarjetas.find(x => x.SolicitudId == _tarjetas.id);
        if (tarjetaSeleccionada != undefined) {
            cuentaSeleccionada = _tarjetas.cuentas.find(x => x.Id == tarjetaSeleccionada.CuentaTarjetaId);
            if (cuentaSeleccionada != undefined) {
                empresaSeleccionada = _tarjetas.empresas.find(x => x.Id == cuentaSeleccionada.EmpresaVisaId);
                if (empresaSeleccionada != undefined) {
                    let tipoEmpresa = tiposEmpresa.find(x => x.Id == empresaSeleccionada.TipoEmpresaId);
                    tipoEmpresa.seleccionada = true;
                }
            }
        }
    }
    else {
        if (_tarjetas.estadoSolicitud == "Borrador") {
            let empresaSeleccionada;
            empresaSeleccionada = _tarjetas.empresas.find(x => x.seleccionada);
            if (empresaSeleccionada != undefined) {
                let tipoEmpresa = tiposEmpresa.find(x => x.Id == empresaSeleccionada.TipoEmpresaId);
                tipoEmpresa.seleccionada = true;
            }
        }
    }
}

function _loadNuevaSolicitudTipoEmpresaInitialStateData(data) {
    LogHelper.In(_loadNuevaSolicitudTipoEmpresaInitialStateData.name, data);

    
    let tipoPersona = _tarjetas.clienteResultadoBusqueda.DatosClientes.TipoPersona;
    let tiposCuenta = JSON.parse(data.GET_ATLAS_CUENTA_TIPO_BY_ADMINISTRADORA).Recordset0.Rows || [];
    let cuentasFiltradas = tiposCuenta.filter(cuenta=>cuenta.TipoPersona == tipoPersona || cuenta.TipoPersona == "A");
    
   let resultado = {
        'tipoEmpresa': cuentasFiltradas,
        'showError': false,
        'permissions': data.CALLER_ID
    };
    seleccionarTipoEmpresa(resultado.tipoEmpresa);

    _dispatch({ type: GET_KIND_PRODUCT_DATA_RESULT, resultado: resultado });
}



// WEBPACK FOOTER //
// ./Portico/Productos/Tarjetas/App/Screens/NuevaSolicitudTipoEmpresa/actions/NuevaSolicitudTipoEmpresaActions.js